import React from 'react';

export default function FilterBar({ filters, onFilterChange }) {
  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value || undefined });
  };

  return (
    <div className="card" style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
      <label>
        Sentiment:
        <select
          value={filters.sentiment || ''}
          onChange={(e) => handleChange('sentiment', e.target.value)}
          style={{ marginLeft: '0.5rem' }}
        >
          <option value="">All</option>
          <option value="positive">Positive</option>
          <option value="neutral">Neutral</option>
          <option value="negative">Negative</option>
        </select>
      </label>

      <label>
        Callback:
        <select
          value={filters.callback_detected ?? ''}
          onChange={(e) => handleChange('callback_detected', e.target.value)}
          style={{ marginLeft: '0.5rem' }}
        >
          <option value="">All</option>
          <option value="true">Detected</option>
          <option value="false">Not Detected</option>
        </select>
      </label>
    </div>
  );
}
